import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss']
})
export class IconButtonComponent {
  @Input()
  icon;

  @Input()
  iconActive;

  @Input()
  activeBackground;

  @Input()
  label = '';

  @Input()
  active = false;

  additionStyle = {};

  constructor() {}

  ngOnInit() {}

  ngAfterContentChecked(): void {
    if (this.active && this.activeBackground) {
      this.additionStyle = {
        'background-color': this.activeBackground,
        'border-color': this.activeBackground
      };
    } else {
      this.additionStyle = {};
    }
  }
}
